// @ts-nocheck
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { Get_PROJECT_TYPE } from '../../store/Lookup/lookupSlice';
import { useTranslation } from 'react-i18next';

const useLookupPROJECTTYPE = () => {
  const dispatch = useDispatch();
  const { i18n } = useTranslation();

  useEffect(() => {
    dispatch(Get_PROJECT_TYPE());
  }, []);

  const { PROJECT_TYPE, loading, error } = useSelector(state => state.Lookup);

  const OptionsPROJECT_TYPE =
    PROJECT_TYPE &&
    PROJECT_TYPE?.map((item, idx) =>
      item.list?.map(list => ({
        value: list.lookupCode,
        label: i18n.language === 'en' ? list.meaning : list.meaning2
      }))
    ).flat();

  return { PROJECT_TYPE, OptionsPROJECT_TYPE, loading, error };
};

export default useLookupPROJECTTYPE;
